import React, { useEffect, useState } from "react";
import DropoutTable from "./ApplicantTableComponent/DropoutTable";
import { getallapplicant, reset } from "../../features/Applicant/applicantSlice";
import { useAppDispatch, useAppSelector } from "../../useStore";
import swal from "sweetalert";

const ApplicantDropouts = () => {
  const [resetID, setResetID] = useState(false)
  const dispatch = useAppDispatch();

  const {
    EvalvationisSuccess,
    UpdateScreeningStatusisSuccess,
    sendOfferisSuccess,
    applicationInterviewisSuccess,
    updateApplicationInterviewStatusisSuccess,
    sendEmailisSuccess,
    shareApplicationisSuccess,
    ScreeningisSuccess,
    applicationassignedisSuccess,
    scheduleApplicantisSuccess,
    updateInterviewStatusisSuccess,
    dropoutToScreeningisSuccess,
    UpdateOfferisSuccess,
    sendForHireisSuccess,
    EditapplicantionisSuccess,
    sendForTranningisSuccess,
    updateTranningisSuccess,
    data,
    isError,
    isLoading,
    message,
  } = useAppSelector((state: { applicant: any }) => state.applicant);

  useEffect(() => {
    if (
      dropoutToScreeningisSuccess ||
      EvalvationisSuccess ||
      UpdateScreeningStatusisSuccess ||
      sendOfferisSuccess ||
      applicationInterviewisSuccess ||
      updateApplicationInterviewStatusisSuccess ||
      sendEmailisSuccess ||
      shareApplicationisSuccess ||
      ScreeningisSuccess ||
      applicationassignedisSuccess ||
      scheduleApplicantisSuccess ||
      updateInterviewStatusisSuccess ||
      UpdateOfferisSuccess ||
      sendForHireisSuccess ||
      EditapplicantionisSuccess ||
      sendForTranningisSuccess ||
      updateTranningisSuccess
    ) {
      const input = { applicationStatus: "DROPOUT" };
      // @ts-ignore 
      dispatch(getallapplicant(input))

      setTimeout(() => {
        dispatch(reset());
      }, 2000);
    }
  }, [EvalvationisSuccess, UpdateScreeningStatusisSuccess, sendOfferisSuccess, applicationInterviewisSuccess, updateApplicationInterviewStatusisSuccess, sendEmailisSuccess, shareApplicationisSuccess, ScreeningisSuccess, applicationassignedisSuccess, scheduleApplicantisSuccess, updateInterviewStatusisSuccess, dispatch, dropoutToScreeningisSuccess, UpdateOfferisSuccess, sendForHireisSuccess, EditapplicantionisSuccess, sendForTranningisSuccess, updateTranningisSuccess]);


  useEffect(() => {
    const input = { applicationStatus: "DROPOUT" };
    // @ts-ignore 
    dispatch(getallapplicant(input))

  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      swal({
        title: "error",
        text: message,
        icon: "error"
      })
      dispatch(reset())
    }
  }, [dispatch, isError, message])



  return (
    <div>
      <DropoutTable
        statusButton={"view-Dropouts-status"}
        Status={"Dropout"}
        pageHeader={"Dropouts"}
        headerTitles={[
          "Edit",
          "Applicant Name",
          "Gender",
          "Date Of Birth",
          "Applied on",
          "Job Profile",
          "View ID",
          "Status",
          "Test Scores",
          "Email",
          "Phone Number",
          "Work Experience",
          "Relevant Work Experience",
          "Location",
          "Current Salary",
          "Expected Salary",
          "Edit"
        ]}
        data={data}
        message={message}
        isError={isError}
        isLoading={isLoading}
        setResetID={setResetID}
      />
    </div>
  );
};

export default ApplicantDropouts;
